import { render, staticRenderFns } from "./MarketingIndex.vue?vue&type=template&id=653acdc0&scoped=true"
import script from "./MarketingIndex.vue?vue&type=script&lang=js"
export * from "./MarketingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653acdc0",
  null
  
)

export default component.exports